var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.436 12.545c1.893 1.588 4.039 3.39 8.189 3.39s6.296-1.802 8.189-3.39c1.79-1.503 3.336-2.8 6.56-2.8 3.226 0 4.772 1.297 6.562 2.8a1.27 1.27 0 0 0 1.763-.132 1.205 1.205 0 0 0-.135-1.725c-1.893-1.589-4.039-3.39-8.19-3.39-4.15 0-6.295 1.801-8.188 3.39-1.79 1.502-3.336 2.8-6.561 2.8s-4.771-1.297-6.561-2.8A1.27 1.27 0 0 0 .3 10.82c-.45.513-.389 1.285.135 1.725z",
    fill: "#78C081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.436 5.854c1.893 1.59 4.039 3.39 8.189 3.39s6.296-1.8 8.189-3.39c1.79-1.502 3.336-2.8 6.56-2.8 3.226 0 4.772 1.298 6.562 2.8.524.44 1.313.381 1.763-.132a1.205 1.205 0 0 0-.135-1.724c-1.893-1.59-4.039-3.39-8.19-3.39-4.15 0-6.295 1.8-8.188 3.39-1.79 1.502-3.336 2.8-6.561 2.8S3.854 5.5 2.064 3.998A1.27 1.27 0 0 0 .3 4.13c-.45.512-.389 1.285.135 1.724zM31.564 17.377c-1.893-1.588-4.039-3.39-8.19-3.39-4.15 0-6.295 1.802-8.188 3.39-1.79 1.503-3.336 2.8-6.561 2.8s-4.771-1.297-6.561-2.8A1.27 1.27 0 0 0 .3 17.51a1.205 1.205 0 0 0 .135 1.725c1.893 1.589 4.039 3.39 8.189 3.39s6.296-1.801 8.189-3.39c1.79-1.502 3.336-2.8 6.56-2.8 3.226 0 4.772 1.298 6.562 2.8a1.27 1.27 0 0 0 1.763-.132c.45-.513.389-1.285-.135-1.725z",
    fill: "#78C081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirFlow);
export default __webpack_public_path__ + "static/media/air-flow.60a8ab3703a002251414628d02dbb5ba.svg";
export { ForwardRef as ReactComponent };